module.exports = __webpack_public_path__ + "media/motus-boule-noire.9188ada1.mp3";